import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const ShieldCheckIcon = (props: SvgProps) => (
  <Svg
    width={56}
    height={56}
    fill="none"
    {...props}
  >
    <Path
      fill="#54945A"
      fillRule="evenodd"
      d="M27.051 6.262a1.488 1.488 0 0 1 1.898 0 33.45 33.45 0 0 0 19.818 7.699c.675.032 1.252.52 1.341 1.191a33.92 33.92 0 0 1 .292 4.449c0 14.455-9.128 26.778-21.934 31.52-.3.11-.631.11-.931 0C14.728 46.378 5.6 34.055 5.6 19.6c0-1.509.1-2.993.292-4.449.089-.67.666-1.159 1.342-1.191A33.45 33.45 0 0 0 27.05 6.262Zm11.747 16.673a2.1 2.1 0 1 0-3.396-2.47l-9.755 13.412-5.262-5.262a2.1 2.1 0 1 0-2.97 2.97l7 7a2.1 2.1 0 0 0 3.183-.25l11.2-15.4Z"
      clipRule="evenodd"
    />
  </Svg>
);
export default ShieldCheckIcon;
